import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-support-info',
  templateUrl: './support-info.component.html',
  styleUrls: ['./support-info.component.css']
})
export class SupportInfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
